module.exports = __webpack_public_path__ + "img/expostyle_1571_kaki_pantone7771c.3a73fe1a.jpg";